/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_Category_Membersempty1Inputs */

const en_cases_settings_category_membersempty1 = /** @type {(inputs: Cases_Settings_Category_Membersempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No case managers are assigned to this category yet.`)
};

/**
* | output |
* | --- |
* | "No case managers are assigned to this category yet." |
*
* @param {Cases_Settings_Category_Membersempty1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cases_settings_category_membersempty1 = /** @type {((inputs?: Cases_Settings_Category_Membersempty1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Category_Membersempty1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_category_membersempty1(inputs)
});
export { cases_settings_category_membersempty1 as "cases_settings_category_membersEmpty" }